import * as React from 'react';

import LoaderSpinner, {
  LoadingSpinnerSize
} from 'shared/components/animations/LoaderSpinner';

import './FormLoader.modules.scss';

const Loader: React.FC = () => (
  <div styleName="loader">
    <LoaderSpinner size={LoadingSpinnerSize.s} centered />
  </div>
);

export default React.memo(Loader);
